"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var company_info_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/designated/company_info"));
var CompanyInfoStore = /** @class */ (function () {
    function CompanyInfoStore(props) {
        this.component = company_info_1.default;
        this.companyInfo = props.companyInfo;
    }
    return CompanyInfoStore;
}());
exports.default = CompanyInfoStore;
